import { useAuthStore } from '@stores/auth.store';

export const getDashboardRoute = (_role) => '/app';

export const getCurrentUserDashboardRoute = () => {
    const role = useAuthStore.getState().role;
    return getDashboardRoute(role);
};
